import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TextField } from '@mui/material';
import { useField } from 'formik';
import { useMyTimezone } from 'components/customer/orgs/MyOrgAPIEndpoints';
// @ts-ignore
import { DateTime } from 'luxon';
// @ts-ignore
//@ts-ignore
import { ensureLuxonDateOnly, dateOnlyFormatPicker, getDateFromMui } from "lib/Formatters";
//@ts-ignore
import { convertToLocalTime } from "lib/DateRuleSetFormatter";

interface MyUsageDatePickerProps {
    name: string;
    label: string;
    minDate?: Date;
    maxDate?: Date;
    inputFormat?: string;
    views?: string[];
    dataCyId?: string;
}

export const MyUsageDatePicker = ({ name, label, minDate, maxDate, inputFormat, views, dataCyId }: MyUsageDatePickerProps) => {
    const timezone = useMyTimezone();
    const [field, , helpers] = useField(name);

    const handleChange = (value: any) => {
        if (!value) return;

        const newDate = ensureLuxonDateOnly(
            convertToLocalTime(getDateFromMui(value), timezone)
        );

        helpers.setValue(newDate);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterLuxon}>
            <DatePicker
                label={label}
                value={field.value ? DateTime.fromISO(field.value) : null}
                onChange={handleChange}
                minDate={minDate}
                maxDate={maxDate}
                format={inputFormat ?? dateOnlyFormatPicker}
                views={views as any}
                slots={{
                    textField: TextField
                }}
                slotProps={{
                    textField: (params: any) => ({
                        ...params,
                        'data-cy-id': dataCyId,
                        inputProps: { ...params.inputProps }
                    })
                }}
            />
        </LocalizationProvider>
    );
};
